import { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const VimeoCarousel = ({ vimeoIds }) => {
  const [current, setCurrent] = useState(0);

  return (
    <div className="space-y-4">
      <motion.div key={current} initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="aspect-video w-full">
        <iframe
          src={`https://player.vimeo.com/video/${vimeoIds[current]}?title=0&byline=0&portrait=0`}
          className="w-full h-full"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title={`Video ${current + 1}`}
        />
      </motion.div>

      <div className="flex items-center justify-between">
        <button
          onClick={() => setCurrent((prev) => (prev > 0 ? prev - 1 : vimeoIds.length - 1))}
          className="flex items-center gap-2 px-4 py-2 border border-[#27272A] text-[#A1A1AA] hover:border-[#007AFF] hover:text-[#007AFF] transition-colors"
        >
          <ChevronLeft size={16} />
          Prev
        </button>
        <div className="flex items-center gap-2">
          {vimeoIds.map((videoId, index) => (
            <button
              key={`video-dot-${videoId}`}
              onClick={() => setCurrent(index)}
              className={`w-2 h-2 rounded-full transition-colors ${
                index === current ? 'bg-[#007AFF]' : 'bg-[#27272A] hover:bg-[#52525B]'
              }`}
              aria-label={`Go to video ${index + 1}`}
            />
          ))}
        </div>
        <button
          onClick={() => setCurrent((prev) => (prev < vimeoIds.length - 1 ? prev + 1 : 0))}
          className="flex items-center gap-2 px-4 py-2 border border-[#27272A] text-[#A1A1AA] hover:border-[#007AFF] hover:text-[#007AFF] transition-colors"
        >
          Next
          <ChevronRight size={16} />
        </button>
      </div>

      <p className="text-center text-[#52525B] text-sm">
        Video {current + 1} of {vimeoIds.length}
      </p>
    </div>
  );
};

const YouTubeLink = ({ youtubeId }) => (
  <a
    href={`https://www.youtube.com/watch?v=${youtubeId}`}
    target="_blank"
    rel="noopener noreferrer"
    className="relative block w-full h-full group"
  >
    <img
      src={`https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`}
      alt="Watch on YouTube"
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-black/50 flex items-center justify-center group-hover:bg-black/40 transition-colors">
      <div className="text-center">
        <div className="w-20 h-20 rounded-full bg-red-600 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
          <svg className="w-8 h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
        <span className="text-white font-bold text-lg">Watch on YouTube</span>
      </div>
    </div>
  </a>
);

export const BlogVideoPanel = ({ post }) => (
  <div className="lg:sticky lg:top-32">
    {post.vimeo_ids && post.vimeo_ids.length > 0 ? (
      <VimeoCarousel vimeoIds={post.vimeo_ids} />
    ) : (
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="aspect-video w-full">
        {post.youtube_id ? (
          <YouTubeLink youtubeId={post.youtube_id} />
        ) : (
          <iframe
            src={`https://player.vimeo.com/video/${post.vimeo_id}?title=0&byline=0&portrait=0`}
            className="w-full h-full"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Featured Video"
          />
        )}
      </motion.div>
    )}
  </div>
);
